import React__default from 'react';
import { DataViewKey } from '@keepeek/commons';
import { Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import KButton from '../../KButtons/index.js';

var EmptyState = function (_a) {
    var isFolderSearch = _a.isFolderSearch, filtersCount = _a.filtersCount, resetFilters = _a.resetFilters, dataViewKey = _a.dataViewKey, _b = _a.hideFolderFiterInActiveFilters, hideFolderFiterInActiveFilters = _b === void 0 ? true : _b;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(Container, { sx: {
            paddingTop: 4,
            paddingBottom: 4
        } },
        !isFolderSearch && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Typography, { sx: {
                    marginBottom: 2
                }, variant: "h3", component: "h1" }, t("components.dataview.empty-state.title")),
            React__default.createElement(Typography, { sx: {
                    marginBottom: 1
                } }, t("components.dataview.empty-state.description")),
            React__default.createElement(KButton, { className: "EmptyState-ResetButton", onClick: function () {
                    return resetFilters({
                        exceptFolderFilter: hideFolderFiterInActiveFilters,
                        exceptBasketFilter: dataViewKey === DataViewKey.BASKET_DETAIL
                    });
                }, variant: "contained" }, t("components.dataview.empty-state.remove-filters")))),
        isFolderSearch &&
            filtersCount === 2 && ( // Case of folder search with only one other filter. So ther are 2 filters
        React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Typography, { sx: {
                    marginBottom: 2
                }, variant: "h3", component: "h1" }, t("components.dataview.empty-state.title")),
            React__default.createElement(Typography, { sx: {
                    marginBottom: 1
                } }, t("components.dataview.empty-state.description.folderId")),
            React__default.createElement(KButton, { className: "EmptyState-ResetButton", onClick: function () {
                    return resetFilters({
                        exceptFolderFilter: true,
                        exceptBasketFilter: dataViewKey === DataViewKey.BASKET_DETAIL
                    });
                }, variant: "contained" }, t("components.dataview.empty-state.remove-filters")))),
        isFolderSearch &&
            filtersCount > 2 && ( // Case of folder search with more than one other filter. So there are more than 2 filters
        React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Typography, { sx: {
                    marginBottom: 2
                }, variant: "h3", component: "h1" }, t("components.dataview.empty-state.folder.search.title")),
            React__default.createElement(Typography, { sx: {
                    marginBottom: 1
                } }, t("components.dataview.empty-state.folder.search.description")),
            React__default.createElement(KButton, { className: "EmptyState-ResetButton", onClick: function () {
                    return resetFilters({
                        exceptFolderFilter: false,
                        exceptBasketFilter: dataViewKey === DataViewKey.BASKET_DETAIL,
                        resetOnlyFolderFilter: true
                    });
                }, variant: "contained" }, t("components.dataview.empty-state.new.search"))))));
};

export { EmptyState as default };
//# sourceMappingURL=index.js.map
